import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_CAMPAIGNS_LIST_QUERY_KEY,
  FINANCE_INFLUENCER_QUERY_KEY,
  VENDOR_BILLING_QUERY_KEY,
} from "../contsants";
import { useEffect } from "react";
import { CampaignService } from "../services/Campaign.service";

export function useGetFinanceInfluencer(campaignInfluencerId: string) {
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: refetchFinanceData,
    isRefetching,
  } = useQuery({
    queryKey: [
      ...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId),
      campaignInfluencerId,
    ],
    queryFn: () => CampaignService.getFinanceInfluencer(campaignInfluencerId),
    enabled: !!campaignInfluencerId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    financeInfluencer: data?.data,
    isLoading,
    isError,
    refetchFinanceData,
    isRefetching,
  };
}
